export default "__VITE_ASSET__BBT8K8_P__"